import { Alert, Box, Button, CircularProgress, Link, Stack, TextField } from "@mui/material";
import { Text } from "@src/lib/ui-react";

import { LoginLayout } from "../../../containers/enter/commonLogin/loginLayout";
import { type ResetPasswordViewProps } from "./ResetPasswordView";

const PASSWORD_MIN_LENGTH = 12;

export function ResetPasswordViewLegacy(props: ResetPasswordViewProps) {
  const {
    step,
    email,
    newPassword,
    confirmPassword,
    isSubmitting,
    error,
    hasActiveSession,
    onNewPasswordChange,
    onConfirmPasswordChange,
    onSubmit,
    onGoToLogin,
  } = props;

  if (step === "success") {
    return (
      <LoginLayout>
        <Stack alignItems="center" spacing={2.5}>
          <Alert severity="success" sx={{ width: "100%" }}>
            Your password has been reset successfully.
          </Alert>
          {!hasActiveSession && (
            <Button fullWidth variant="contained" onClick={onGoToLogin}>
              Sign in with your new password
            </Button>
          )}
        </Stack>
      </LoginLayout>
    );
  }

  return (
    <LoginLayout>
      <Stack spacing={2.5}>
        <Text align="center" variant="h4">
          Set new password
        </Text>

        {error && (
          <Alert severity="error" sx={{ textAlign: "left" }}>
            {error}
          </Alert>
        )}

        <Box
          noValidate
          component="form"
          onSubmit={(formEvent: React.FormEvent) => {
            onSubmit(formEvent);
          }}
        >
          <Stack spacing={2}>
            <Text align="left" color="text.secondary" variant="body2">
              Email: {email}
            </Text>
            <TextField
              fullWidth
              required
              autoComplete="new-password"
              disabled={isSubmitting}
              label="New Password"
              size="small"
              type="password"
              value={newPassword}
              onChange={(event) => {
                onNewPasswordChange(event.target.value);
              }}
            />
            <TextField
              fullWidth
              required
              autoComplete="new-password"
              disabled={isSubmitting}
              label="Confirm New Password"
              size="small"
              type="password"
              value={confirmPassword}
              onChange={(event) => {
                onConfirmPasswordChange(event.target.value);
              }}
            />
            <Text color="text.secondary" variant="caption">
              Password must be at least {PASSWORD_MIN_LENGTH} characters and include uppercase and
              lowercase letters.
            </Text>
            <Button
              fullWidth
              disabled={isSubmitting || !newPassword || !confirmPassword || !email}
              type="submit"
              variant="contained"
            >
              {isSubmitting ? <CircularProgress size={24} /> : "Set new password"}
            </Button>
            {!hasActiveSession && (
              <Link
                component="button"
                sx={{ alignSelf: "center" }}
                type="button"
                underline="hover"
                variant="body2"
                onClick={onGoToLogin}
              >
                Back to sign in with password
              </Link>
            )}
          </Stack>
        </Box>
      </Stack>
    </LoginLayout>
  );
}
